import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";

interface ErrorBannerProps {
  title?: string;
  error: unknown;
  onRetry?: () => void;
}

/**
 * Standard error surface for failed TanStack Query requests. Pulls the
 * `Error.message` (or a fallback) and offers an explicit Retry button so
 * users aren't stuck without a recovery path.
 */
export function ErrorBanner({ title = "Something went wrong", error, onRetry }: ErrorBannerProps) {
  const message = error instanceof Error ? error.message : String(error);
  return (
    <Alert variant="destructive">
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription className="space-y-3">
        <p className="font-mono text-xs">{message}</p>
        {onRetry ? (
          <Button variant="outline" size="sm" onClick={onRetry}>
            Retry
          </Button>
        ) : null}
      </AlertDescription>
    </Alert>
  );
}
